import {BaseApiTemplateService, Core2Config} from "../../../shared";
import {ConversationAgentSquadLinkContainerModel} from "../../../../../../../models/aggregates/alg/cc/conversation";
import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";

@Injectable({providedIn: 'root'})
export class ConversationAgentSquadLinkService extends BaseApiTemplateService<ConversationAgentSquadLinkContainerModel>{
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ALG_CC_MODULE + 'conversation-agent-squad-links';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ALG_CC_MODULE + 'conversation-agent-squad-links';
    this.httpClient = http;
  }
}
